export default {
  emailLogs(state) {
    return state.emailLogs
  },
}
